import { useCallback, useState } from 'react';
import { DateTime } from 'luxon';
import { PrizepicksDatePicker } from '@library/components/datePicker';
import { ResetIconButton } from '@library/components/buttons';

export interface PollsFiltersProps {
  handleSelectDate: (value?: string) => void;
}

export const PollsFilters = ({ handleSelectDate }: PollsFiltersProps) => {
  const [startDatePickerOpen, setStartDatePickerOpen] = useState(false);
  const [localDate, setLocalDate] = useState<Date | undefined>();

  const handleDateChange = useCallback(
    (date: Date) => {
      handleSelectDate(DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'));
      setLocalDate(date);
    },
    [handleSelectDate, setLocalDate]
  );

  const handleClearDateClick = useCallback(() => {
    handleSelectDate(undefined);
    setLocalDate(undefined);
  }, [handleSelectDate, setLocalDate]);

  return (
    <>
      <div className="flex items-center justify-center">
        <PrizepicksDatePicker
          disabled={false}
          handleChange={handleDateChange}
          open={startDatePickerOpen}
          setOpen={setStartDatePickerOpen}
          value={localDate}
          monthsShown={1}
          placeholder="Choose a Date"
        />
      </div>
      <div className="flex items-center justify-center">
        <ResetIconButton
          label="Reset Filter"
          onClick={handleClearDateClick}
          disabled={localDate === undefined}
        />
      </div>
    </>
  );
};
